export default __webpack_public_path__ + "static/media/pin.03b7e6ea.png";